import { AppEnv } from 'meta/app'

export type AppState = {
  env?: AppEnv
}

export const initialState: AppState = {}
